<template>
    <div id="down-beta-page">
        <div class="top_part">
            <div class="top_part_back" :class="status">
                <img class="long move-left"  src="@/assets/down2/top_long_back.png" alt="">
                <!-- :class="flag ? 'move-left' : 'move-right'" -->
                <img class="top_back_img" src="@/assets/down2/top_back_img.png" alt="">
                <img class="top_bottom_img" src="@/assets/down2/top_bottom_img.png" alt="">
                <img class="top_logo" src="@/assets/down2/top_logo.png" alt="">
            </div>
            <div class="slogan_div">
                <img class="slogan" src="@/assets/down2/slogan.png" alt="">
            </div>
            <div class="data_div clearfix">
                <div class="box left">
                    <div class="title">
                        <span>多空指标</span>
                        <span :class="status">{{{'less strong': '强烈看空', 'less': '看空', 'center': '中立', 'more': '看多', 'more strong': '强烈看多'}[status]}}</span>
                    </div>
                    <div class="value clearfix">
                        <div class="left">
                            <span class="num" :style="{'color': '#EB4236'}">{{lessMoreObj.less}}</span><br/>
                            <span class="des">看空</span>
                        </div>
                        <div class="left">
                            <span class="num" :style="{'color': '#9598A6'}">{{lessMoreObj.center}}</span><br/>
                            <span class="des">中立</span>
                        </div>
                        <div class="left">
                            <span class="num" :style="{'color': '#34A756'}">{{lessMoreObj.more}}</span><br/>
                            <span class="des">看多</span>
                        </div>
                    </div>
                </div>
                <div class="box left">
                    <img class="gauge_back" src="@/assets/down2/gauge_back.png" alt="">
                    <div class="pointer_box" :style="{'transform': `rotate(${angle - 90}deg)`}">
                        <img class="pointer" src="@/assets/down2/pointer.png" alt="">
                    </div>
                    <span class="a">强烈看空</span>
                    <span class="b">看空</span>
                    <span class="c">中立</span>
                    <span class="d">看多</span>
                    <span class="e">强烈看多</span>
                </div>
            </div>
            <div class="button_box">
                <!-- <button style="background: #333333; color: #9598A6;" @click="goAppStore">iOS 下载</button> -->
                <button @click="iosDown">iOS 下载</button>
                <button @click="androidDown">Android 下载</button>
            </div>
        </div>
        <div class="introduce_part">
            <h2>交易所钱包监控</h2>
            <div class="intro">全方位监测充提数据 资金流向无所遁形</div>
            <img src="@/assets/down2/intro1.png" alt="">
        </div>
        <div class="introduce_part">
            <h2>宏观数据</h2>
            <div class="intro">纵览市场宏观数据 把握投资机会</div>
            <img src="@/assets/down2/intro2.png" alt="">
        </div>
        <div class="introduce_part">
            <h2>合约爆仓</h2>
            <div class="intro">探究市场多空数据 揭晓合约秘密</div>
            <img src="@/assets/down2/intro3.png" alt="">
        </div>
        <div class="introduce_part">
            <h2>币种异动</h2>
            <div class="intro">汇集币种异动数据 察觉市场信号</div>
            <img src="@/assets/down2/intro4.png" alt="">
        </div>
        <div class="introduce_part">
            <h2>毫秒级K线</h2>
            <div class="intro">实时捕捉数据变化 跟踪市场走势</div>
            <img src="@/assets/down2/intro5.png" alt="">
        </div>
        <div class="bottom_part">
            <img class="bottom_logo" src="@/assets/down/bottom_logo.png" alt="">
            <img class="bottom_back" src="@/assets/down/bottom_back.png" alt="">
        </div>
        <div id="mask" v-show="maskViewShow" @click="maskViewShow = false">
            <span class="mask-tip">请在浏览器中打开</span>
            <img src="@/assets/down/tip_arrow.png"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BetaDownload',
    data() {
        return {
            maskViewShow: false,
            iosUrl: '',
            androidUrl: '',

            status: 'less',
            flag: true,
            angle: 0,
            lessMoreObj: {
                less: 12,
                center: 5,
                more: 3 
            }
        }
    },
    mounted() {
        // const script = document.createElement('script')
        // script.src = 'https://s9.cnzz.com/z_stat.php?id=1278708975&web_id=1278708975'
        // script.language = 'JavaScript'
        // document.body.appendChild(script)
        // this.getDownUrl();
        // let interval = setInterval(() => {
        this.getRandomNum();
        // }, 800);
    },
    watch: {
        // $route() {
        //     if (window._czc) {
        //         let location = window.location
        //         let contentUrl = location.pathname + location.hash
        //         let refererUrl = '/'
        //         window._czc.push(['_trackPageview', contentUrl, refererUrl])
        //     }
        // }
    },
    methods: {
        // getDownUrl() {
        //     this.$MyAxios.get('/api/versions/downloadUrl', {}, response => {
        //         if(response.code == 1) {
        //             this.iosUrl = response.data.ios;
        //             this.androidUrl = response.data.android;
        //         }
        //     })
        // },

        iosDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                window.location.href = 'itms-services://?action=download-manifest&url=https://misc.jinguozi.net/mainifest.plist';
                // window.location.href = `itms-services://?action=download-manifest&url=${this.iosUrl}`;
			}
        },

        androidDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
				var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                let url = "http://test.misc.jinguozi.net/JGZ.apk"
				iframe.src = "javascript: '<script>location.href=\"" + url + "\"<\/script>'";
				document.getElementsByTagName('body')[0].appendChild(iframe);
			}
        },

        goAppStore() {
            // let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			// if(isWeChat){
			// 	this.maskViewShow = true;
			// }else{
            //     window.location.href = 'itms-services://?action=download-manifest&url=https://test.misc.jinguozi.net/mainifest.plist';
            //     // window.location.href = `https://apps.apple.com/cn/app/id1466013710`;
            // }
            alert('暂未开放')

        },

        getRandomNum() {
            let random = 0;
            this.flag = true;
            let interval = setInterval(() => {
                this.angle = random * 180;
                // this.status = '';
                if(random >= 0 && random < 0.2){
                    this.status = 'less strong';
                    this.lessMoreObj = {
                        less: 17,
                        center: 2,
                        more: 1 
                    }
                }else if(random >= 0.2 && random < 0.4){
                    this.status = 'less';
                    this.lessMoreObj = {
                        less: 12,
                        center: 5,
                        more: 3 
                    }
                }else if(random >= 0.4 && random < 0.6){
                    this.status = 'center';
                    this.lessMoreObj = {
                        less: 3,
                        center: 13,
                        more: 4 
                    }
                }else if(random >= 0.6 && random < 0.8){
                    this.status = 'more';
                    this.lessMoreObj = {
                        less: 6,
                        center: 5,
                        more: 11
                    }
                }else if(random >= 0.8 && random <= 1){
                    this.status = 'more strong';
                    this.lessMoreObj = {
                        less: 2,
                        center: 3,
                        more: 15 
                    }
                }
                if(random >= 1){
                    this.flag = false
                }
                if(random <= 0){
                    this.flag = true
                }
                this.flag ? random = random + 0.01 : random = random - 0.01;
            }, 50);
        }
    }
}
</script>

<style lang='less'>
#down-beta-page {
	height: auto;
	width: 100%;
	background: #ffffff;
	// padding-top: 38px;
	background-size: 100% 100%;
	background-repeat: no-repeat;
    position: relative;
    img {
        pointer-events: none;
    }
    .top_part {
        width: 100%;
        height: 760px;
        background:#FFFFFF;
        // margin-bottom: 80px;
        .top_part_back {
            width: 100%;
            height: 250px;
            position: relative;
            overflow: hidden;
            background: #ffffff;
            // background: linear-gradient(90deg,rgba(245,174,50,1) 0%,rgba(254,97,43,1) 100%);
            // transition: 0.3s;
            // transition-property: opacity;
            // transition-duration: 5s;
            // transition-timing-function: ease;
            // opacity: 0;
            .long {
                height: 250px;
                width: 2250px;
                position: absolute;
                left: 0;
                top: -1px;
                // z-index: 1;
                &.move-left {
                    animation: moveLeft 10s infinite;
                    -webkit-animation:moveLeft 10s infinite;
                }
                &.move-right {
                    animation: moveRight 5s ease;
                    -webkit-animation: moveRight 5s ease;
                }
            }
            &.less {
                // background:linear-gradient(270deg,rgba(245,174,50,1) 0%,rgba(254,97,43,1) 100%);
                // opacity: 1;
            }
            &.center {
                // background:linear-gradient(270deg,rgba(160,215,134,1) 0%,rgba(245,174,50,1) 100%);
                // opacity: 0.9;
            }
            &.more {
                // background:linear-gradient(90deg,rgba(160,215,134,1) 0%,rgba(95,187,95,1) 100%); 
                // opacity: 1;
            }
            margin-bottom: 42px;
            .top_back_img {
                position: absolute;
                width: 750px;
                height: 250px;
                left: 0;
                top: 0;
            }
            .top_bottom_img {
                position: absolute;
                width: 752px;
                height: 48px;
                bottom: -1px;
                left: 0;
            }
            .top_logo {
                height: 77px;
                width: 230px;
                left: 50%;
                transform: translateX(-50%);
                position: absolute;
                top: 100px;
                z-index: 1;
            }
        }
        .slogan_div {
            height: 30px;
            text-align: center;
            margin-bottom: 40px;
            .slogan {
                height: 28.8px;
                width: 611.28px;
            }
        }
        .data_div {
            margin-bottom: 70px;
            .box:nth-of-type(1) {
                width: 244px;
                margin: 16px 30px 0 40px;
                .title {
                    text-align: left;
                    margin-bottom: 8px;
                    span {
                        display: inline-block;
                    }
                    span:nth-of-type(1) {
                        width: 120px;
                        color: #33333A;
                        font-size: 26px;
                        font-weight: bold;
                        margin-right: 5px;
                        vertical-align: middle;
                        display: table-cell;
                    }
                    span:nth-of-type(2) {
                        padding: 0px 8px;
                        height: 30px;
                        display: table-cell;
                        // width: 70px;
                        width: auto;
                        color: #ffffff;
                        font-size: 20px;
                        font-weight: bold;
                        text-align: center;
                        vertical-align: middle;
                        background: #34A756;
                        border-radius: 15px;
                        transition: 1s ease;
                        // transition-property: background-color;
                        &.less {
                            background-color: #EB4236;
                        }
                        &.center {
                            background-color: #9598A6;
                        }
                        &.more {
                            background-color: #34A756;
                        }
                    }
                }
                .value {
                    span {
                        display: inline-block;
                    }
                    .num {
                        font-size: 34px;
                        line-height: 42px;
                        font-weight: bold;
                        font-family: 'DINPRO';
                        margin-bottom: 14px;
                        transition: 0.5s ease;
                    }
                    .des {
                        font-size: 24px;
                        line-height: 33px;
                        color: #33333A;
                    }
                    .left {
                        font-size: 24px;
                    }
                    .left:nth-of-type(2) {
                        margin: 0 40px;
                    }
                }
            }
            .box:nth-of-type(2) {
                width: 418px;
                height: 152px;
                margin: 0 0px 0 0;
                // background: rgba(255,94,0,0.3);
                position: relative;
                .gauge_back {
                    height: 108px;
                    width: 216px;
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: 0;
                    z-index: 1;
                }
                .pointer_box {
                    height: 124px;
                    width: 26px;
                    position: absolute;
                    left: ~'calc(50% - 13px)' ;
                    bottom: -62px;
                    // transform: translateX(-50%);
                    transform: rotate(75deg);
                    transition: 0.1s;
                    
                }
                .pointer {
                    height: 76px;
                    width: 26px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
                span {
                    font-size: 20px;
                    color: #9598A6;
                    position: absolute;
                }
                .a {
                    left: 2px;
                    bottom: 0;
                }
                .b {
                    left: 50px;
                    bottom: 56px;
                }
                .c {
                    left: 50%;
                    transform: translateX(-50%);
                    top: 0;
                }
                .d {
                    right: 50px;
                    bottom: 56px;
                }
                .e {
                    right: 2px;
                    bottom: 0;
                }
            }
        }
        .button_box {
            position: relative;
        }
        button {
            height: 90px;
            width: 270px;
            outline: none;
            border: none;
            cursor: pointer;
            border-radius: 45px;
            background: #FFA41F;
            box-shadow:0px 6px 16px rgba(255,102,0,0.3);
            position: absolute;
            color: #ffffff;
            font-size: 32px;
            font-weight: bold;
            &:nth-of-type(1) {
                left: 80px;
            }
            &:nth-of-type(2) {
                right: 80px;
            }
            // &:nth-of-type(3) {
            //     top: 554px;
            // }
        }
    }
    .introduce_part {
        width: 100%;
        height: auto;
        background: #FFFFFF;
        text-align: center;
        margin-bottom: 40px;
        img {
            height: auto;
            width: 750px;
            vertical-align: middle;
        }
        h2 {
            color: #33333A;
            font-size: 50px;
            line-height: 70px;
            font-weight: bold;
            margin-bottom: 16px;
        }
        .intro {
            display: block;
            color: #9598A6;
            font-size: 30px;
            line-height: 42px;
        }
    }
    .bottom_part {
        width: 100%;
        height: 263px;
        background: #FFFFFF;
        position: relative;
        margin-top: 80px;
        .bottom_back {
            width: 750px;
            height: 263px;
        }
        .bottom_logo {
            position: absolute;
            bottom: 76px;
            left: 50%;
            height: 100px;
            width: 280.5px;
            transform: translateX(-50%);
        }
    }
}
@keyframes moveLeft
{
	0% {left: 0vw;}
    50% {left: -200vw;}
    100% {left: 0vw;}
}

@-webkit-keyframes moveLeft /*Safari and Chrome*/
{
	0% {left: 0vw;}
    50% {left: -200vw;}
    100% {left: 0vw;}
}

@keyframes moveRight
{
	from {left: -200vw;}
	to {left: 0px;}
}

@-webkit-keyframes moveRight /*Safari and Chrome*/
{
	from {left: -200vw;}
	to {left: 0px;}
}
</style>
